
export const environment = {
    production: 'false',
    API_KEY: 'AIzaSyAZ-cwtygcM6QV7ttxNPXsg98aQI8nEQ3M',
    FAST_API: 'https://seatow-fast-api-dev.seatow.com/',
    JOB_ID: 'abc123',
    POLL_INTERVAL: 10000,
    SEATOW_API: 'https://sea-tow-dev-api.seatow.com/',
    REQUEST_TOKEN: 'WnZr4u7x!A%D*G-KaPdSgUkXp2s5v8y/',
};
